import React, { Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import DynamicLighting from "./DynamicLight";
import ClassroomBackdrop from "./ClassroomBackdrop";

const ClassroomScene = ({
  GradientBackground,
  currentHour,
  ambientIntensity,
  isDaytime,
  currentIndoorTemp,
  radiatorPipeValues = [0, 0, 0],
  maxHeatingPower,
}) => {

  const radiatorThrottlePercents = radiatorPipeValues.map(
    (value) => (value / (maxHeatingPower / 3)) * 100,
  );

  return (
    <div className="canvas-placeholder">
      <GradientBackground gameHour={currentHour}>
        <Canvas
          shadows
          camera={{ position: [0, 2, 5], fov: 50 }}
          style={{
            width: "100vw",
            transition: ".5s all",
            height: "100vh",
          }}
        >
          <Suspense fallback={null}>
            <DynamicLighting
              currentHour={currentHour}
              ambientIntensity={ambientIntensity}
            />
          </Suspense>
        </Canvas>
      </GradientBackground>
      <ClassroomBackdrop
        isDaytime={isDaytime}
        currentIndoorTemp={currentIndoorTemp}
        radiatorThrottlePercents={radiatorThrottlePercents}
      />
    </div>
  );
};

export default ClassroomScene;
